__turbopack_context__.v({
  "activeTab": "CupTabs-module__KiiO5W__activeTab",
  "authors": "CupTabs-module__KiiO5W__authors",
  "awayClub": "CupTabs-module__KiiO5W__awayClub",
  "bracket": "CupTabs-module__KiiO5W__bracket",
  "bracketPenalty": "CupTabs-module__KiiO5W__bracketPenalty",
  "branch": "CupTabs-module__KiiO5W__branch",
  "column": "CupTabs-module__KiiO5W__column",
  "cupIcon": "CupTabs-module__KiiO5W__cupIcon",
  "filter": "CupTabs-module__KiiO5W__filter",
  "final": "CupTabs-module__KiiO5W__final",
  "finalBranch": "CupTabs-module__KiiO5W__finalBranch",
  "fixture": "CupTabs-module__KiiO5W__fixture",
  "fixtureList": "CupTabs-module__KiiO5W__fixtureList",
  "fixtureScore": "CupTabs-module__KiiO5W__fixtureScore",
  "goalColumns": "CupTabs-module__KiiO5W__goalColumns",
  "homeClub": "CupTabs-module__KiiO5W__homeClub",
  "match": "CupTabs-module__KiiO5W__match",
  "matchWrap": "CupTabs-module__KiiO5W__matchWrap",
  "meta": "CupTabs-module__KiiO5W__meta",
  "note": "CupTabs-module__KiiO5W__note",
  "pair": "CupTabs-module__KiiO5W__pair",
  "penalty": "CupTabs-module__KiiO5W__penalty",
  "quarterStage": "CupTabs-module__KiiO5W__quarterStage",
  "right": "CupTabs-module__KiiO5W__right",
  "round": "CupTabs-module__KiiO5W__round",
  "scroll": "CupTabs-module__KiiO5W__scroll",
  "stage": "CupTabs-module__KiiO5W__stage",
  "tab": "CupTabs-module__KiiO5W__tab",
  "table": "CupTabs-module__KiiO5W__table",
  "tabs": "CupTabs-module__KiiO5W__tabs",
  "team": "CupTabs-module__KiiO5W__team",
  "winner": "CupTabs-module__KiiO5W__winner",
  "withoutFirst": "CupTabs-module__KiiO5W__withoutFirst",
});
